import { defineComponent as _defineComponent } from 'vue'
import { agree } from '@/js/lib/api/account/your/account';
import { useUserStore } from '@/js/lib/store/user';
import { info, loading } from '@/js/lib/ui';
import { PERMISSION_ID_POLICY_UPDATE_202403 } from '@/js/data/permission';
import IButton from '@/js/components/molecules/IButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'update-policy-202403',
  setup(__props) {

const userStore = useUserStore();
const onClickAgree = () => {
  loading({
    asyncFunc: async () => {
      try {
        await agree({ settingId: PERMISSION_ID_POLICY_UPDATE_202403 });
        userStore.updatePermission([PERMISSION_ID_POLICY_UPDATE_202403]);
      } catch (error) {
        info(error, { fadeOut: false });
      }
    },
  });
};

return { __sfc: true,userStore, onClickAgree, IButton }
}

})